import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const errorResponseSchema = z.object({
  error: z.object({
    message: z.string(),
    code: z.string().optional(),
  }),
});

export const conversationMessageSchema = z.object({
  id: z.number(),
  type: z.enum(['request-info', 'response', 'rejection', 'resent', 'accepted', 'other']),
  // 'connectme' = customer booking note captured on the ConnectMe app (SC-6269).
  sender: z.enum(['skewbworks', 'core', 'connectme']),
  timestamp: z.string(),
  message: z.string(),
  createdBy: z.string().nullable(),
  eventType: z.string(),
  attachments: z
    .array(
      z.object({
        fileName: z.string(),
        S3Key: z.string(),
        mimeType: z.string().optional(),
      }),
    )
    .optional()
    .default([]),
});

export const conversationsResponseSchema = z.array(conversationMessageSchema);

export type ConversationMessage = z.infer<typeof conversationMessageSchema>;
export type ConversationsResponse = z.infer<typeof conversationsResponseSchema>;

export const jobConversationsContract = c.router({
  getJobConversations: {
    method: 'GET',
    path: '/:jobId/conversations',
    pathParams: z.object({
      jobId: z.coerce.number(),
    }),
    responses: {
      200: conversationsResponseSchema,
      404: errorResponseSchema,
      500: errorResponseSchema,
    },
    summary: 'Get communication history for a job',
    description:
      'Returns all communication log entries for a job, ordered chronologically. ' +
      'Includes more-info requests, replies, rejections, and acceptances.',
  },
});
